import { useState, useCallback } from "react";

export const usePanelZoom = (initialZoom = 1.0, minZoom = 0.75, maxZoom = 1.0, step = 0.05) => {
  const [zoom, setZoom] = useState(() => {
    const saved = localStorage.getItem("filterPanel_zoom");
    return saved ? Math.min(maxZoom, Math.max(minZoom, parseFloat(saved))) : initialZoom;
  });

  const zoomIn = useCallback(() => {
    setZoom((prev) => {
      const next = Math.min(maxZoom, Math.round((prev + step) * 100) / 100);
      localStorage.setItem("filterPanel_zoom", next);
      return next;
    });
  }, [maxZoom, step]);

  const zoomOut = useCallback(() => {
    setZoom((prev) => {
      const next = Math.max(minZoom, Math.round((prev - step) * 100) / 100);
      localStorage.setItem("filterPanel_zoom", next);
      return next;
    });
  }, [minZoom, step]);

  const resetZoom = useCallback(() => {
    setZoom(1.0);
    localStorage.setItem("filterPanel_zoom", 1.0);
  }, []);

  const setExactZoom = useCallback((val) => {
    const next = Math.min(maxZoom, Math.max(minZoom, val));
    setZoom(next);
    localStorage.setItem("filterPanel_zoom", next);
  }, [minZoom, maxZoom]);

  return { zoom, zoomIn, zoomOut, resetZoom, setExactZoom, minZoom, maxZoom };
};
